import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, retry, catchError } from 'rxjs';
import { RatesResponse } from '../_models/rates';
import { GatewayService } from './gateway.service';
import { LoggingService } from './logging.service';
import { environment } from "../../environments/environment";
import brandInfo from "../../environments/brand.json";
import { Store } from "@ngrx/store";
import { saveRatesRequest } from '../_actions/rates.actions';

@Injectable({
  providedIn: 'root'
})
export class WrapperService {

  constructor(private httpClient: HttpClient,
    private gatewayService: GatewayService,
    private loggingService: LoggingService,
    private store: Store<{}>,
  ) { }

  // Http Options
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }

  // Utility method to clean odometer values
  private cleanOdometerValue(odometer: any): string {
    if (odometer == null || odometer === undefined) {
      return '';
    }
    return odometer.toString().replace(/[\s,]/g, '');
  }

  //Url Params for request

  get_rates(ratesObject): Observable<RatesResponse> {

    console.log('Rate API hit', ratesObject);

    let productCode = '';

    if (ratesObject.brandName === 'NCESI') {
      if (ratesObject.product === 'PPM') {
        productCode = 'PPM'
      } else {
        productCode = 'NASP'
      }
    } else if (ratesObject.brandName === 'Vroom') {
      if (ratesObject.product === 'EVSC') {
        productCode = 'VRED'
      } else {
        productCode = 'VRVD'
      }
    } else if (ratesObject.brandName === 'Schomp') {
      productCode = 'SCVD'
    } else if (ratesObject.brandName === 'GMC' || ratesObject.brandName === 'Cadillac'  || ratesObject.brandName === 'Buick' || ratesObject.brandName === 'Chevrolet') {
      productCode = 'VSC'
    } else if (brandInfo.brand === 'HPP' || brandInfo.brand === 'Genesis') {
      const page = JSON.parse(sessionStorage.getItem('pagesFlow'))
      if (page && page.landingPage === 'prepaid-maintenance' || page && page.landingPage === 'pre-paid-maintenance') {
        productCode = 'PPM'
      } else if (page && page.landingPage === 'vehicle-protection' || page && page.landingPage === 'electric-vehicle-protection' || page && page.landingPage === 'truck-protection') {
        productCode = 'VSC'
      }
    } else if (brandInfo.brand === 'REV') {
      productCode = 'VSC'
    }

    if (brandInfo.useFakeAPI) {
      return this.httpClient.get<RatesResponse>(this.gatewayService.baseUrl + 'dtc-wrapper-srvc/productsDetails', {
        params: {
          brandName: ratesObject.brandName,
          VIN: ratesObject.vin,
          saleDate: ratesObject.saleDate,
          odometer: this.cleanOdometerValue(ratesObject.odometer),
          inServiceDate: ratesObject.inServiceDate,
          financeType: ratesObject.financeType,
          isAfterSale: ratesObject.isAfterSale,
          vehiclePurchaseDate: ratesObject.vehiclePurchaseDate,
          vehicleCondition: ratesObject.vehicleCondition,
          customerState: ratesObject.customerState,
          financeAmount: ratesObject.financeAmount,
          vehicleCost: ratesObject.vehicleCost,
          vehicleMSRP: ratesObject.vehicleMSRP,
          lienholderName: ratesObject.lienholderName,
          vehicleSfId: ratesObject.vehicleSfId,
          productCode: productCode,
          language: brandInfo.brand === 'NCESI' ? sessionStorage.getItem('preferredLanguage') ? sessionStorage.getItem('preferredLanguage') : 'en-ca' : null
        }
      })
        .pipe(
          retry(1),
          catchError((httpResponse) => {
            return this.loggingService.handleErrorWithD2CCapture(httpResponse, "medium", "get_rates")
          })
        )
    } else {

      // Capture the current date when rates are requested
      const currentDate = new Date();
      const ratesEffectiveDate = currentDate.getFullYear() + '-' + 
        String(currentDate.getMonth() + 1).padStart(2, '0') + '-' + 
        String(currentDate.getDate()).padStart(2, '0');
      sessionStorage.setItem('ratesEffectiveDate', ratesEffectiveDate);

      const ratesBody = {
        vin: ratesObject.vin,
        saledate: ratesEffectiveDate,
        inServiceDate: ratesObject.inServiceDate,
        odometer: this.cleanOdometerValue(ratesObject.odometer),
        brandName: brandInfo.brand,
        customerState: ratesObject.customerState,
        product: productCode,
        language: brandInfo.brand === 'NCESI' ? sessionStorage.getItem('preferredLanguage') ? sessionStorage.getItem('preferredLanguage') : 'en-ca' : null,
        dealerId: ratesObject.dealer
      }

      this.store.dispatch(saveRatesRequest(ratesBody))
      
      return this.httpClient.post<RatesResponse>(`${environment.apiUrl}/v1/api/rates/getRates`, ratesBody)
        .pipe(
          retry(1),
          catchError((httpResponse) => {
            return this.loggingService.handleErrorWithD2CCapture(httpResponse, "medium", "get_rates")
          })
        )
    }
  }
}
